import React from "react";

const Error = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 24 24"
    fill="none"
  >
    <circle cx="12" cy="12" r="12" fill="#FCE7E3" />
    <path
      d="M12.2129 5C8.34727 5 5.21289 8.13438 5.21289 12C5.21289 15.8656 8.34727 19 12.2129 19C16.0785 19 19.2129 15.8656 19.2129 12C19.2129 8.13438 16.0785 5 12.2129 5ZM14.7973 14.6594L13.766 14.6547L12.2129 12.8031L10.6613 14.6531L9.62852 14.6578C9.55977 14.6578 9.50352 14.6031 9.50352 14.5328C9.50352 14.5031 9.51445 14.475 9.5332 14.4516L11.566 12.0297L9.5332 9.60938C9.51432 9.58647 9.50385 9.5578 9.50352 9.52812C9.50352 9.45937 9.55977 9.40312 9.62852 9.40312L10.6613 9.40781L12.2129 11.2594L13.7645 9.40938L14.7957 9.40469C14.8645 9.40469 14.9207 9.45937 14.9207 9.52969C14.9207 9.55937 14.9098 9.5875 14.891 9.61094L12.8613 12.0312L14.8926 14.4531C14.9113 14.4766 14.9223 14.5047 14.9223 14.5344C14.9223 14.6031 14.866 14.6594 14.7973 14.6594Z"
      fill="#E36F58"
    />
  </svg>
);
export default Error;
